import React from "react";

export const QuizThanxMessage = ({message}) => {
    return <div className="quiz__initilal">
        <p>Опрос завершен.</p>
        <p>{message}</p>
    </div>
}

export default QuizThanxMessage;